import { markPreviousPageCompletedPayload } from '../../../types/Navigation/MarkPreviousPageCompletedPayload';
import { setCompletedPage } from './setCompletedPage';

export const markPreviousPageCompleted = async (payload: markPreviousPageCompletedPayload) => {
  const { currentPageName, patientInfo } = payload;

  // TURN THE NAVIGATION OBJECT INTO AN ARRAY
  const navArray = Object.entries(patientInfo.navObj).map(([key, value]) => {
    return { [key]: { ...value } };
  });

  if (navArray.length === 0) {
    return;
  }
  // FILTER OUT DISABLED PAGES
  const filteredNavArray = navArray.filter((navItem) => {
    const key = Object.keys(navItem)[0];
    const value = navItem[key];
    return !value.disabled;
  });

  // SORT THE ARRAY BY BASE ORDER
  filteredNavArray.sort((a, b) => {
    return a[Object.keys(a)[0]].baseOrder - b[Object.keys(b)[0]].baseOrder;
  });

  // FIND THE CURRENT PAGE
  const currentPageIndex = filteredNavArray.findIndex((navItem) => {
    return Object.keys(navItem)[0] === currentPageName;
  });

  // RETURN THE PREVIOUS PAGE OBJECT IN THE ARRAY
  const prevPageObj = filteredNavArray[currentPageIndex - 1];

  if (!prevPageObj) {
    console.warn(
      `No previous page found when executing markPreviousPageCompleted from ${currentPageName}. This is likely because the previous page was already marked complete.`,
    );
    return;
  }
  if (Object.keys(prevPageObj)[0] === currentPageName) {
    console.warn(
      'Ignoring request to mark page as complete because the previous page is the same as the current page.',
    );
  }
  await setCompletedPage({ name: Object.keys(prevPageObj)[0], value: true, patientInfo });
};
